<template>
  <div v-loading="listLoading" class="tabList">
    <div v-show="propsObj.link" class="search-result">
      <div><span class="result-title">{{ wd | titleFilter }}</span> - 学校</div>
    </div>
    <div v-if="dataList && dataList.length>0" class="list">
      <div class="list-box">
        <div v-for="(item, index) in dataList" :key="index" class="list-item" @click="openWindow(item)">
          <div class="imgbox">
            <img v-if="item.logoFilePath" :src="item.logoFilePath" class="imgsrc" @error="defoutImg($event)">
            <img v-else :src="require('@/assets/img/moren.png')" class="imgsrc">
          </div>
          <div class="text">
            <div class="title">
              {{ item.name }}  <span class="right" />
            </div>
            <div class="textContent">
              <p v-show="item.teachingTypeName">
                {{ item.teachingTypeName }}
              </p>
              <p>{{ item.provinceName }}{{ item.cityName }}{{ item.areaName }}{{ item.officeAddr }}</p>
            </div>
            <span class="pdr20"><img :src="require('@/assets/img/vector.png')" class="pdr5">{{ item.resourceNum }}</span>
            <span class="pdr20"><img :src="require('@/assets/img/vector1.png')" class="pdr5">{{ item.likeNum }}</span>
            <span class="pdr20"><img :src="require('@/assets/img/vector2.png')" class="pdr5">{{ item.accessNum }}</span>
          </div>
          <div v-show="item.officialFilePath" class="wechat">
            <img :src="item.officialFilePath" width="88">
            <div>
              关注官方微信
            </div>
          </div>
        </div>
      </div>
    </div>
    <global-empty
      v-else
      :label="`暂无数据~`"
      link-it="3"
      height="300"
    />
    <pagination
      v-show="searchForm.total>0&&propsObj.link"
      :total="searchForm.total"
      :page.sync="searchForm.pageNum"
      :limit.sync="searchForm.pageSize"
      @pagination="pageCurriculumList"
      @handleSizeChange="handleSizeChange"
    />
  </div>
</template>
<script>
import { getAppList } from '@/api/search';
import ENVIRONMENT from '@/utils/environment';

export default {
  name: 'TabList',
  props: {
    propsObj: {
      default: Object,
      type: Object
    },
    wd: {
      default: String,
      type: String
    },
    searchClick: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      link: '',
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      listLoading: true,
      dataList: []
    };
  },
  watch: {
    searchClick() {
      this.getList();
    },
    $route() {
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 头像为null或者加载错误时设置默认头像
    defoutImg(event) {
      event.target.src = require('@/assets/img/moren.png');
    },
    async getList() {
      this.listLoading = true;
      if (!this.propsObj.link) {
        this.searchForm.pageSize = 4; // 全部类型只查询四条
      }
      const params = {
        code: 'S14',
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        q: this.wd
      };
      await getAppList(params).then(res => {
        if (res.data.S14.list && res.data.S14.list.length > 0) {
          this.dataList = res.data.S14.list;
          this.searchForm.total = res.data.S14.total;
        } else {
          this.dataList = [];
          this.searchForm.total = 0;
        }
        setTimeout(() => {
          var list = document.getElementsByClassName('list-box');
          if (this.dataList.length < 1) {
            this.height = 150;
          } else if (list[0].offsetHeight) {
            this.height = list[0].offsetHeight;
          }
          const data = {
            result: this.searchForm.total,
            height: this.height
          };
          window.parent.postMessage(data, '*');
        }, 500);
        this.listLoading = false;
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getList();
    },
    handlerLink() {
    // this.$router.push('/'+this.propsObj.link+'/'+this.propsObj.propsId);
    },
    openWindow(item) {
      console.log(item);
      window.open(ENVIRONMENT.resoureUrl + '/#/schoolResources/detailPage?schoolId_fordetail=' + item.schoolCode);
    }
  }
};
</script>
<style scoped lang="scss">
.list{
  padding: 20px 0;
  color:#555;
  .list-box{
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px;
    padding-bottom: 10px;
    cursor: pointer;
    &:nth-child(even){
       padding-left: 20px;
    }
    &:nth-child(odd){
       padding-right: 20px;
    }
    .imgbox {
      width: 148px;
      height: 148px;
      padding: 20px;
      box-shadow: 0 0 12px rgba(0, 0, 0, .1);
      display: flex;
      justify-content: center;
      align-items: center;
      .imgsrc {
        border-radius: 20px;
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
      }
    }
    .text {
      flex: 1;
      margin-left: 20px;
      line-height: 24px;
      .title{
        font-size: 17px;
        font-weight: bold;

      }
    }
  }
}
.search-result{
  display: flex;
  justify-content: space-between;
  padding: 20px 0 0 0;
  margin: 0 16px 0 20px;
  font-weight: bold;
  font-size: 18px;
  div{
    font-size: 18px;
    color: #787878;
    font-weight: 500;
  }
  .result-title{
  font-weight: bold !important;
  font-size: 18px !important;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
.text > p {
  font-weight: 400;
  color: #787878;
  font-family: Microsoft YaHei;
}
.text > .textContent {
  margin:16px 0
}
.icon{
  width: 18px;
  height: 16px;
  margin-right: 4px;
}
.icon-box{
  margin-top: 20px;
  margin-left:-30px;
  span{
    margin-left: 30px;
    height: 13px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #787878;
  }
}
</style>

